import axios from 'axios';
import { checkProductQuantity } from '@/services/CartService';
import store from '../store';

export default {
  getAllProductCategories() {
    return axios.get('/api/product-categories');
  },

  getProductCategoriesForHomepage() {
    return axios.get(`/api/product-categories?in_homepage=${true}`);
  },

  getHomepageProductsForCategory(slug) {
    return axios.get(`/api/home-management/products/product-category/${slug}`);
  },

  getProductBrandsForHomepage() {
    return axios.get(`/api/product-brands?in_homepage=${true}`);
  },

  getAllProductBrands() {
    return axios.get('/api/product-brands');
  },

  getProductBrand(slug) {
    return axios.get(`/api/product-brands/${slug}`);
  },

  getProductsForBrandAndCategory(brandId, category) {
    return axios.get(`/api/home-management/products/product-category/${category}?brand=${brandId}`);
  },

  getStrings() {
    return axios.get('/api/products?category=STR');
  },
};

export function getProduct(sku) {
  return axios.get(`/api/products/${sku}`);
}

export function addProductToCart(givenProduct, qty) {
  const product = givenProduct;
  const vatRate = 100 + product.vat_rate;
  product.quantity = qty;
  const quantity = checkProductQuantity(product);
  const totalPrice = product.is_discounted ? product.discounted_price * quantity : product.price * quantity;
  const totalPriceWithVat = (totalPrice * vatRate) / 100;
  const singlePriceWithVat = product.is_discounted ? (product.discounted_price * vatRate) / 100 : (product.price * vatRate) / 100;
  const vat = totalPriceWithVat - totalPrice;

  const productToAdd = {
    ...product,
    quantity,
    totalPrice,
    totalPriceWithVat,
    singlePriceWithVat,
    vat,
  };

  const roundedTotalFromSinglePrice = Math.round(singlePriceWithVat) * quantity;
  const roundedTotalPriceWithVat = Math.floor(totalPriceWithVat);
  productToAdd.roundedTotalPriceWithVat = roundedTotalPriceWithVat;

  if (roundedTotalPriceWithVat - roundedTotalFromSinglePrice === 1) {
    productToAdd.roundedTotalPriceWithVat = roundedTotalFromSinglePrice;
  }

  store.dispatch('cart/addProduct', productToAdd);
}

export function sendProductRequestByMail(id, quantity) {
  return axios.post(`/api/products/${id}/request?quantity=${quantity}`);
}
